<script>
  import { inertia } from '@inertiajs/svelte';
  import { menuOpenState, activePathState } from '@/js/utils/stores.js';

  let activePath;
  activePathState.subscribe((value) => {
    activePath = value;
  });

  export let data;

  function closeMenu() {
    menuOpenState.set((open = false));
  }
</script>

{#if data.title}
  <h2 class="h4 menu-title">{data.title}</h2>
{/if}
<nav class="menu" aria-label="Main menu">
  <ul>
    {#each data.items as item}
      <li class="menu-item">
        <a
          class="menu-link"
          class:active={activePath.includes(item.url)}
          href={item.url}
          use:inertia
          on:click={closeMenu}
        >
          <i class="menu-link__icon isax isax-arrow-right-3" />
          <span>{@html item.label}</span>
        </a>
      </li>
    {/each}
  </ul>
</nav>

<style lang="scss">
  .menu {
    margin-top: 2rem;
  }

  .menu-title {
    @include resp-max('s') {
      font-size: 2.4rem;
    }
  }

  .menu-item {
    @include resp-max('m') {
      margin: 1.5rem 0;
    }
    @include resp-min('m') {
      margin: 0.75rem 0;
    }

    transition: all 0.2s;

    &:hover {
      @include gradient('blue', 135deg);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .menu-link {
    display: flex;
    align-items: center;
    gap: 1rem;

    &.active {
      @include gradient('blue', 135deg);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    &__icon {
      color: var(--grey-1);
    }
  }
</style>
